'use client';
import React, { JSX, useEffect, useState, type FC } from 'react';
import styles from './index.module.scss';
import clsx from 'clsx';

import { Drawings } from '@/data/drawings';
import { ArtPieces } from '@/data/artPieces';

import { ArtPiece } from '@/components/atoms/artpiece';

export const WorkSection: FC = (): JSX.Element => {
  const [threeDimensional, setThreeDimensional] = useState(false);

  const artpiecesReverse = ArtPieces.slice(0).reverse();

  useEffect(() => {
    const images = document.querySelectorAll(`.${styles.artPieceImg}`);
    const handleImageLoad = (img: HTMLImageElement) => {
      if (img.naturalWidth > img.naturalHeight) {
        img.parentElement?.classList.add(styles.horizontal);
      } else {
        img.parentElement?.classList.add(styles.vertical);
      }
    };

    images.forEach((img) => {
      const imageElement = img as HTMLImageElement;
      if (imageElement.complete) {
        handleImageLoad(imageElement);
      } else {
        imageElement.onload = () => handleImageLoad(imageElement);
      }
    });
  }, []);

  return (
    <>
      <div className={styles.switch}>
        <h2>
          <span
            onClick={() => setThreeDimensional(false)}
            className={clsx(
              threeDimensional ? styles.notActive : styles.active
            )}
          >
            2D
          </span>{' '}
          or{' '}
          <span
            onClick={() => setThreeDimensional(true)}
            className={clsx(
              threeDimensional ? styles.active : styles.notActive
            )}
          >
            3D
          </span>
        </h2>
      </div>

      {threeDimensional ? (
        <ul className={styles.artPiecesSection}>
          {artpiecesReverse.map((artPiece, index) => (
            <ArtPiece
              key={`${artPiece.imageSRC}-${index}`}
              material={artPiece.material}
              size={artPiece.size}
              src={artPiece.imageSRC}
              className={styles.artPiece}
              classNameImg={styles.artPieceImg}
            />
          ))}
        </ul>
      ) : (
        <ul className={styles.drawingSection}>
          {Drawings.map((drawing, index) => (
            <ArtPiece
              key={`${drawing.imageSRC}-${index}`}
              material={drawing.material}
              size={drawing.size}
              src={drawing.imageSRC}
              className={styles.drawing}
              classNameImg={styles.drawingImg}
            />
          ))}
        </ul>
      )}
    </>
  );
};
